module.exports = __webpack_public_path__ + "img/127-sri-lanka.64e22cbb.svg";